import { NextPage } from 'next';
import WhyStreamYardPage from '@sy/app-client/src/ssrAdapter/pages/WhyStreamYardPage';

import MarketingTemplate from '~/components/templates/MarketingTemplate';
import buildMetatadata from '~/utils/buildMetadata';
import { getMarketingNavigation } from '~/utils/getNavigation';
import { translate, buildGetServerSideProps } from '../getServerSideProps';
import type { CommonContext, InferProps } from '../getServerSideProps';

const WhyStreamYard: NextPage<InferProps<typeof getServerSideProps>> = ({
	featureFlags,
	navigation,
	user,
}) => (
	<MarketingTemplate
		activePage="/why-streamyard"
		featureFlags={featureFlags}
		navigation={navigation}
		user={user}
	>
		<WhyStreamYardPage />
	</MarketingTemplate>
);

const customServerSideProps = async (context: CommonContext) => {
	const { featureFlags, locale, query } = context;

	return {
		props: {
			metadata: buildMetatadata({
				title: translate(locale, 'common.title.whyStreamYard'),
			}),
			navigation: await getMarketingNavigation({ featureFlags, locale, query }),
		},
	};
};

export const getServerSideProps = buildGetServerSideProps({
	customServerSideProps,
	translationNamespaces: ['common', 'auth', 'landing', 'landingWhyStreamYard'],
});

export default WhyStreamYard;
